/** Horário da loja: situação (aberta/fechada) e configuração. */
import type { ConfigHorarioLoja } from "@ydchat/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api, ErroApi } from "./api";

export interface SituacaoHorario {
  config: ConfigHorarioLoja;
  fuso: string;
  aberta: boolean;
  proximaAbertura: string | null;
  abertura: string;
  iaDisponivel: boolean;
}
const chave = ["horario-loja"];

export function useHorarioLoja() {
  return useQuery({
    queryKey: chave,
    queryFn: () => api.get<SituacaoHorario>("/equipe/horario"),
    staleTime: 60_000,
    refetchInterval: 60_000,
  });
}

export function useSalvarHorario() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (c: ConfigHorarioLoja) => api.put<SituacaoHorario>("/equipe/horario", c),
    onSuccess: (r) => {
      qc.setQueryData(chave, r);
      toast.success("Horário da loja salvo!");
    },
    onError: (e) => toast.error(e instanceof ErroApi ? e.message : "Não foi possível salvar."),
  });
}
